<script setup lang="ts">
import { router } from '@inertiajs/vue3'
import { ref } from 'vue'

import { Button } from '@/components/ui/button'
import { verifyIdentityLoanApplicationPath } from '@/routes'

const props = defineProps<{ applicationId: string }>()

const processing = ref(false)

function verify() {
  if (processing.value) return
  processing.value = true
  router.post(verifyIdentityLoanApplicationPath(props.applicationId), {}, {
    preserveScroll: true,
    onFinish: () => { processing.value = false },
  })
}
</script>

<template>
  <Button size="sm" variant="outline" class="w-full" :disabled="processing" @click="verify">
    {{ processing ? 'Verifying...' : 'Verify Identity' }}
  </Button>
</template>
